module.exports = __webpack_public_path__ + "static/media/popup.d24d5f2b.png";